//https://www.npmjs.com/package/intersection-observer
require("intersection-observer");

export default () => {
    // console.log('intersection observer pollyfill loaded');
};
